(function setupBundleChatLauncher(root) {
  'use strict';

  var builder = document.querySelector('[data-judes-bundle-builder]');
  if (!builder) return;

  var stateKey = '__judesBundleChatLauncher';
  if (root[stateKey] && typeof root[stateKey].destroy === 'function') {
    root[stateKey].destroy();
  }

  var frame = null;
  var animationFrame = 0;
  var styleTimer = 0;
  var observer = null;
  var stopped = false;
  var interactiveSelector = [
    'button:not([disabled])',
    'summary',
    'a[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])'
  ].join(',');

  function rectsOverlap(first, second) {
    return Math.min(first.right, second.right) > Math.max(first.left, second.left)
      && Math.min(first.bottom, second.bottom) > Math.max(first.top, second.top);
  }

  function isVisible(element) {
    if (!element.getClientRects().length) return false;
    var style = root.getComputedStyle(element);
    return style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
  }

  function updateCollisionState() {
    animationFrame = 0;
    if (!frame || !frame.isConnected) {
      frame = document.querySelector('#gorgias-chat-container iframe#chat-button');
    }
    if (!frame) return;

    var launcherRect = frame.getBoundingClientRect();
    var overlapsControl = launcherRect.width > 0 && launcherRect.height > 0
      && Array.prototype.some.call(builder.querySelectorAll(interactiveSelector), function (control) {
        return isVisible(control) && rectsOverlap(launcherRect, control.getBoundingClientRect());
      });

    frame.classList.toggle('judes-chat-launcher--avoiding-control', overlapsControl);
    if (overlapsControl) frame.setAttribute('aria-hidden', 'true');
    else frame.removeAttribute('aria-hidden');
  }

  function scheduleCollisionCheck() {
    if (animationFrame || stopped) return;
    animationFrame = root.requestAnimationFrame(updateCollisionState);
  }

  function findChatButton() {
    frame = document.querySelector('#gorgias-chat-container iframe#chat-button');
    if (!frame) return false;
    scheduleCollisionCheck();
    return true;
  }

  function start() {
    if (stopped) return;
    var attempts = 0;
    styleTimer = root.setInterval(function () {
      attempts += 1;
      if (findChatButton() || attempts >= 200) {
        root.clearInterval(styleTimer);
        styleTimer = 0;
      }
    }, 50);

    root.addEventListener('scroll', scheduleCollisionCheck, { passive: true });
    root.addEventListener('resize', scheduleCollisionCheck, { passive: true });
    observer = new MutationObserver(scheduleCollisionCheck);
    observer.observe(builder, { attributes: true, childList: true, subtree: true });
    scheduleCollisionCheck();
  }

  function destroy() {
    stopped = true;
    if (styleTimer) root.clearInterval(styleTimer);
    if (animationFrame) root.cancelAnimationFrame(animationFrame);
    if (observer) observer.disconnect();
    root.removeEventListener('scroll', scheduleCollisionCheck);
    root.removeEventListener('resize', scheduleCollisionCheck);
    if (frame) {
      frame.classList.remove('judes-chat-launcher--avoiding-control');
      frame.removeAttribute('aria-hidden');
    }
  }

  root[stateKey] = {
    destroy: destroy,
    update: updateCollisionState,
    rectsOverlap: rectsOverlap,
    isVisible: isVisible
  };

  if (root.GorgiasChat && typeof root.GorgiasChat.init === 'function') {
    root.GorgiasChat.init().then(start).catch(start);
  } else {
    root.addEventListener('gorgias-widget-loaded', start, { once: true });
  }
}(typeof globalThis !== 'undefined' ? globalThis : window));
